import ProjectLayout from "./developer_project_layout";
import { ProjectContextProvider } from "./context/developer_project_context";

// this displays the layout for project page
const ProjectPage = () => {
  return (
    <ProjectContextProvider>
      <ProjectLayout />
    </ProjectContextProvider>
  );
};

export default ProjectPage;